import { ITextField } from '@fluentui/react';
import { IPPrimaryButton, IPSeparator } from 'baseComponents';
import { IPStack } from 'baseComponents/Stack/IPStack';
import { IPTextField } from 'baseComponents/TextField/IPTextField';
import { globalStackTokensGapSmall } from 'globalStyles';
import React, { createRef } from 'react';
import { useTranslation } from 'react-i18next';

interface IAddComboBoxListItem {
  itemDescription: string;
  setItemDescription: (itemDescription: string) => void;
  onAddListItem: () => void;
  allowEdit: boolean;
  singleLineEdit?: boolean;
}

export const AddComboBoxListItem = (props: IAddComboBoxListItem) => {
  const { t } = useTranslation(['comboBoxItem']);
  const checkInputRef = createRef<ITextField>();

  return (
    <IPStack tokens={globalStackTokensGapSmall} horizontal={props.singleLineEdit}>
      {!props.singleLineEdit && <IPSeparator />}
      <IPStack.Item grow>
        <IPTextField
          itemRef=""
          componentRef={checkInputRef}
          value={props.itemDescription}
          onChange={(event: React.FormEvent<HTMLInputElement | HTMLTextAreaElement>, newValue?: string) => {
            if (!newValue) {
              props.setItemDescription('');
            } else props.setItemDescription(newValue);
          }}
          placeholder={t('comboBoxItem:ComboBoxList.AddPlaceHolder')}
          style={{ resize: 'vertical', maxHeight: 200 }}
          multiline={!props.singleLineEdit}
        />
      </IPStack.Item>
      <IPStack.Item>
        <IPStack horizontal tokens={globalStackTokensGapSmall} verticalAlign="center">
          <IPPrimaryButton
            disabled={props.itemDescription === '' || !props.allowEdit}
            onClick={() => {
              checkInputRef.current?.focus();
              props.onAddListItem();
            }}
          >
            {t('comboBoxItem:ComboBoxList.Add')}
          </IPPrimaryButton>
        </IPStack>
      </IPStack.Item>
    </IPStack>
  );
};
